import React, { useState } from 'react';
import { NCZIEhrExtractEnvelope, NCZIEntry } from '../../../Interfaces/ncziTypes';
import useNCZICommandProcess from '../../../Hooks/useNCZICommandProcess';
import { useEffectAsync } from '../../../../../helpers';
import NCZICommandResult from '../../NCZICommandResult/NCZICommandResult';
import { GetPatientDPNHistory } from '../../../Commands/GetPatientDPNHistory';
import EHRResult from '../../EHR/EHRResult/EHRResult';
import ElectronicDPNListItems from '../List/ElectronicDPNListItems';
import Loading from '../../../../../Components/Loading';

interface Props {
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	electronicConfirmation: NCZIEntry;
	disableCreate?: boolean;
}

const ElectronicDPNHistoryModalContent: React.FC<Props> = props => {
	const { patientIdentifier, electronicConfirmation, onClose, disableCreate = false } = props;
	const [historyResult, setHistoryResult] = useState<NCZIEhrExtractEnvelope|null>(null);

	const { processingCommandId, processCommand, isProcessing } =
		useNCZICommandProcess({
			onFinish: (commandId, result) => {
				setHistoryResult(result);
			},
			hideSuccess: true
		});

	const handleCloseDetailModal = (needReload: boolean) => {
		onClose(needReload);
	}

	useEffectAsync(async () => {
		const GetHistoryCommand = GetPatientDPNHistory({
			patientCode: patientIdentifier,
			confirmationId: electronicConfirmation.recordId!
		});

		await processCommand(GetHistoryCommand);
	}, []);

	if (isProcessing && processingCommandId) {
		return <NCZICommandResult commandId={processingCommandId} />;
	}

	if(historyResult === null) {
		return <Loading />;
	}

	const historyItems = historyResult?.ehrExtract?.items[0]?.items || [];

	return (
		<>
			<EHRResult ehrResult={historyResult?.result} />
			<ElectronicDPNListItems items={historyItems} onCloseDetail={handleCloseDetailModal} patientIdentifier={patientIdentifier} history={true} disableCreate={disableCreate} />
		</>
	);
};

export default ElectronicDPNHistoryModalContent;
